// Rotas dos grupos de permissão - feature nativa do core (substitui Custom Roles
// Enterprise). Não usa featureFlag e o gating fino é via permitted_keys
// (settings.permission_groups) no backend; a UI verifica via usePermissions.
import { frontendURL } from 'dashboard/helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

import PermissionGroupsIndex from './pages/PermissionGroupsIndexPage.vue';
import PermissionGroupCreate from './pages/PermissionGroupCreatePage.vue';
import PermissionGroupEdit from './pages/PermissionGroupEditPage.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/permission-groups'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'permission_groups_index',
            params: to.params,
          }),
        },
        {
          path: 'list',
          name: 'permission_groups_index',
          component: PermissionGroupsIndex,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: 'new',
          name: 'permission_groups_new',
          component: PermissionGroupCreate,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: 'edit/:id',
          name: 'permission_groups_edit',
          component: PermissionGroupEdit,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
      ],
    },
  ],
};
